/* eslint-disable jsx-a11y/anchor-is-valid */
import classnames from 'classnames';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { insertPopoverContainer } from '@bingads-webui-campaign/fluctuation-common';
import { mergeStyleSets, DefaultButton, Text, Link } from '@fluentui/react';
import { CopilotToggleCustomEvent, LiveAgentQueue } from '@bingads-webui-react/msa-copilot-common';
import { GridTooltip } from '@bingads-webui-campaign/grid-tooltip';

// TODO: replace this with util function from copilot-live-agent once build issue is resolved
// Bug 9089477: [Copilot][CTA] Cloudbuild warning when importing copilot-live-agent
const isEnglishOnlyChatSupportedLocale = (locale) => {
  if (!locale) return false;

  const ENGLISH_ONLY_SUPPORTED_LOCALES = [
    'bg-bg',
    'cs-cz',
    'el-gr',
    'fi-fi',
    'fil-ph',
    'hi-in',
    'hr-hr',
    'hu-hu',
    'ko-kr',
    'lt-lt',
    'ms-my',
    'nb-no',
    'pl-pl',
    'ro-ro',
    'ru-ru',
    'th-th',
    'tr-tr',
    'uk-ua',
    'zh-cn',
    'zh-hk',
    'zh-tw',
  ];

  const lowerLocale = locale.toLocaleLowerCase();
  return ENGLISH_ONLY_SUPPORTED_LOCALES.includes(lowerLocale);
};

export const conversionDeliveryStatusContainerId = 'conversion-delivery-status-tooltip';

export const dismissConversionStatusCallout = () => {
  const calloutElement = document.getElementById(conversionDeliveryStatusContainerId);
  if (calloutElement) {
    ReactDOM.unmountComponentAtNode(calloutElement);
  }
};

export const renderConversionDeliveryStatusTooltip = ({
  i18n, event, item, view, activity, isConnectWithExpertEnabled,
}) => {
  const styles = mergeStyleSets({
    content: {
      marginBottom: '10px',
      marginTop: '10px',
      rowGap: '10px',
      display: 'flex',
      flexDirection: 'column',
    },
    ctaButton: {
      marginTop: '10px',
    },
    ctaFooter: {
      display: 'block',
      marginTop: '16px',
      paddingTop: '4px',
      marginBottom: '-16px',
      borderTop: '1px solid #E9E9E9',
      color: '#838383',
    },
  });
  const { right } = event.target.getBoundingClientRect();
  const calloutMaxWidth = 325; // this value is defined in global style
  const placement = right + calloutMaxWidth > window.innerWidth ? 'left' : 'right';

  const noEligibleGoalText = {
    title: _TL_('Missing primary conversion goal'),
    description: _TL_('This campaign does not have a main conversion goal configured, which may result in missing conversion tracking. Please review your campaign settings to assign a main goal.'),
    learnMoreHref: 'https://help.ads.microsoft.com/#apex/ads/en/56689/2-500',
    learnMoreText: _TL_('Learn more about conversion goals.'),
  };

  const tagUnverifiedText = {
    title: _TL_('Unverified UET tag'),
    description: _TL_('One or more of your main conversion goals have an unverified tag, which resulted in receiving no events. This could lead to missing conversion data. Please ensure the UET tag is properly implemented.'),
    learnMoreHref: 'https://help.ads-int.microsoft.com/#apex/ads/en/56692/1/en-US/#ext:vnext_offlineconversions',
    learnMoreText: _TL_('Learn more about UET tracking.'),
  };

  const tagInactiveText = {
    title: _TL_('Inactive UET tag'),
    description: _TL_('The UET tag for this campaign\'s main goal hasn\'t recorded any events in the last 24 hours, which may result in incomplete conversion tracking. Please check your tag configuration to ensure it is tracking correctly.'),
    learnMoreHref: 'https://help.ads-int.microsoft.com/#apex/ads/en/56692/1/en-US/#ext:vnext_offlineconversions',
    learnMoreText: _TL_('Learn more about UET tracking.'),
  };

  const noRecentOfflineText = {
    title: _TL_('No offline conversions uploaded in last 7 days'),
    description: _TL_('Go to your offline goals to upload conversions that may be associated to this campaign.'),
    learnMoreHref: 'https://help.ads.microsoft.com/#apex/ads/en/56852/2',
    learnMoreText: _TL_('Learn more'),
  };

  const consentModeWarning = {
    title: _TL_('Action required: Ensure proper implementation of consent signals'),
    description: _TL_('To avoid any negative impact on conversion attribution and remarketing segments for users visiting your websites from the European Economic Area (EEA), the United Kingdom, and Switzerland, implement Consent Mode or the Transparency and Consent Framework (TCF) with your UET tags.'),
    learnMoreHref: 'https://help.ads.microsoft.com/apex/index/3/en/60119',
    learnMoreText: _TL_('Learn more'),
  };

  const textStrings = {
    NoEligibleGoal: noEligibleGoalText,
    TagUnverified: tagUnverifiedText,
    TagInactive: tagInactiveText,
    NoRecentOfflineConversion: noRecentOfflineText,
    ConsentModeWarning: consentModeWarning,
  };

  const goalStatus = item && item.GoalStatusDetails && item.GoalStatusDetails.length > 0 && item.GoalStatusDetails[0].GoalDeliveryStatus;

  const Id = item && item.Id;

  const text = textStrings[goalStatus];

  insertPopoverContainer(conversionDeliveryStatusContainerId);
  const tooltipProps = {
    parentView: view,
    popoverId: 'conversion-delivery-status-tooltip-id',
    target: event.currentTarget,
    show: true,
    onClose: dismissConversionStatusCallout,
    onMouseLeave: dismissConversionStatusCallout,
    closeButton: false,
    placement,
    focusLockContent: true,
    content: (
      <>
        <div className={classnames('conversion-delivery-status-tooltip', styles.content)} variant="small">
          <Text className={styles.title} block variant="xLarge">
            {i18n.getString(text.title)}
          </Text>
          <Text className={styles.body} variant="small">
            {i18n.getString(text.description)}
            &nbsp;
            {!isConnectWithExpertEnabled ? (
              <Link
                onClick={() => {
                  if (activity) {
                    activity.trace(`[ConversionDeliveryStatusPopup] - LearnMore Link clicked - campaignId: ${Id}`);
                  }
                  window.open(text.learnMoreHref, '_blank');
                }}
                aria-label={i18n.getString(text.learnMoreText)}
              >
                {i18n.getString(text.learnMoreText)}
              </Link>
            ) : (
              <>
                <div className="conversion-delivery-status-tooltip-learn-more">
                  <DefaultButton
                    className={styles.ctaButton}
                    onClick={() => {
                      if (activity) {
                        activity.trace(`[ConversionDeliveryStatusPopup] - LearnMore Button clicked - campaignId: ${Id}`);
                      }
                      window.open(text.learnMoreHref, '_blank');
                    }}
                  >
                    {i18n.getString(_TL_('Learn more'))}
                  </DefaultButton>
                </div>
                <div className="conversion-delivery-status-tooltip-connect-with-expert">
                  <DefaultButton
                    className={styles.ctaButton}
                    onClick={() => {
                      if (activity) {
                        activity.trace(`[ConversionDeliveryStatusPopup] - Connect with expert Button clicked - campaignId: ${Id}`);
                      }
                      const customEvent = new CopilotToggleCustomEvent({
                        detail: {
                          eventType: 'action',
                          eventSource: 'conversionDeliveryStatusPopup',
                          eventData: {
                            ActionId: 'liveAgentSupport',
                            liveAgentParameters: {
                              queue: LiveAgentQueue.ShoppingAndUET,
                              problemDescription: i18n.getString(
                                _TL_('Campaign Id: {{campaignId}}, Campaign Name: {{campaignName}}, UET Status: {{uetStatus}}'),
                                {
                                  campaignId: item.Id,
                                  campaignName: item.Name,
                                  uetStatus: i18n.getString(text.title),
                                }
                              ),
                            },
                          },
                        },
                      });
                      document.dispatchEvent(customEvent);
                      dismissConversionStatusCallout();
                    }}
                  >
                    {i18n.getString(_TL_('Connect with an expert'))}
                  </DefaultButton>
                  {isEnglishOnlyChatSupportedLocale(i18n.getLocale()) && (
                    <Text variant="small" className={styles.ctaFooter}>
                      {i18n.getString(_TL_('Support chat is in English only'))}
                    </Text>
                  )}
                </div>
              </>
            )}
          </Text>
        </div>
      </>
    ),
  };

  ReactDOM.render(
    <GridTooltip {...tooltipProps} />,
    document.getElementById(conversionDeliveryStatusContainerId)
  );
};

export const hideConversionDeliveryStatusTooltip = ({ event, view }) => {
  if ($(event.relatedTarget).closest('#conversion-delivery-status-tooltip').length === 0) {
    view.trigger('closePopup');
  }
};
